import http from "@/utils/axios";

export default {
  namespaced: true,
  state: {
    docLanguages: null,
  },
  getters: {
    getAllDocLanguages: (state) => state.docLanguages,
    getDocLangById: (state) => (id) =>
      state.docLanguages.find((docLang) => docLang.id === id),
  },
  mutations: {
    setAllDocLanguages(state, docLanguages) {
      state.docLanguages = docLanguages;
    },
  },
  actions: {
    async fetchDocLanguages({ commit }) {
      const response = await http.get("/doctor/languages");
      const docLanguages = response.data;
      commit("setAllDocLanguages", docLanguages);
    },
  },
};
